import { useParams, Link } from 'react-router-dom'
import { Container } from '@/components/layout/Container'
import { getJournalArticleBySlug } from '@/data/journal'

export function JournalArticle() {
  const { slug } = useParams()
  const article = getJournalArticleBySlug(slug ?? '')

  if (!article) {
    return (
      <Container className="py-32 text-center">
        <h1 className="font-display text-3xl text-carbon">Article not found</h1>
        <Link to="/journal" className="mt-4 inline-block text-carbon hover:underline">Back to journal</Link>
      </Container>
    )
  }

  return (
    <article className="pt-28 pb-24">
      <div className="relative h-[40vh] min-h-[300px]">
        <img
          src={article.image}
          alt={article.title}
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-ink/50" />
      </div>

      <Container className="mt-12 max-w-3xl">
        <Link to="/journal" className="text-sm text-carbon hover:underline">← Journal</Link>

        <p className="mt-6 text-xs uppercase tracking-[0.15em] text-carbon/60">
          {article.publishedAt} · {article.readTime} min read
        </p>

        <h1 className="mt-3 font-display text-4xl normal-case text-carbon">
          {article.title.toLowerCase()}
        </h1>

        <div className="prose prose-invert mt-8 max-w-none text-carbon/70">
          {article.body.split('\n\n').map((paragraph, i) => (
            <p key={i} className="mb-6 leading-relaxed">{paragraph}</p>
          ))}
        </div>
      </Container>
    </article>
  )
}
